import { FormGroup, ValidationErrors } from '@angular/forms';

export class AtLeastOneTrueValidation {
  static validate(formGroup: FormGroup): ValidationErrors | null {
    const controls = formGroup.value;
    const isAtLeastOneTrue = Object.values(controls).some((value) => value === true);
    return isAtLeastOneTrue ? null : { atLeastOneTrue: true };
  }
}
